/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddStationDto,
  CreateFactoryDto,
  CreateZoneDto,
  EditStationDto,
  FactoriesControllerListFactoriesParams,
  FactoryComplexityMappingDto,
  FactoryDto,
  FactoryListItemDto,
  FactoryQualitySettingsDto,
  FactoryTopologyDto,
  OperationsStationsGridBulkToggleDto,
  OperationsStationsGridBulkToggleResultDto,
  OperationsStationsGridDto,
  RenameZoneDto,
  ReorderStationsDto,
  ReorderZonesDto,
  StationNodeDto,
  UpdateFactoryDto,
  UpdateFactoryQualitySettingsDto,
  ZoneNodeDto
} from '../schemas';

import { customFetch } from '../../custom-fetch.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type factoriesControllerListFactoriesResponse200 = {
  data: FactoryListItemDto[]
  status: 200
}

export type factoriesControllerListFactoriesResponse400 = {
  data: void
  status: 400
}

export type factoriesControllerListFactoriesResponse401 = {
  data: void
  status: 401
}

export type factoriesControllerListFactoriesResponse403 = {
  data: void
  status: 403
}

export type factoriesControllerListFactoriesResponse404 = {
  data: void
  status: 404
}

export type factoriesControllerListFactoriesResponseSuccess = (factoriesControllerListFactoriesResponse200) & {
  headers: Headers;
};
export type factoriesControllerListFactoriesResponseError = (factoriesControllerListFactoriesResponse400 | factoriesControllerListFactoriesResponse401 | factoriesControllerListFactoriesResponse403 | factoriesControllerListFactoriesResponse404) & {
  headers: Headers;
};

export type factoriesControllerListFactoriesResponse = (factoriesControllerListFactoriesResponseSuccess | factoriesControllerListFactoriesResponseError)

export const getFactoriesControllerListFactoriesUrl = (params: FactoriesControllerListFactoriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/factories?${stringifiedParams}` : `/factories`
}

/**
 * Returns factories owned by the specified partner (by UUID), including is_archived. Callers must be a member of the requested partner; admins bypass this check.
 * @summary List factories for a partner
 */
export const factoriesControllerListFactories = async (params: FactoriesControllerListFactoriesParams, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerListFactoriesResponse> => {

  return customFetch<factoriesControllerListFactoriesResponse>(getFactoriesControllerListFactoriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFactoriesControllerListFactoriesQueryKey = (params?: FactoriesControllerListFactoriesParams,) => {
    return [
    `/factories`, ...(params ? [params] : [])
    ] as const;
    }


export const getFactoriesControllerListFactoriesQueryOptions = <TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(params: FactoriesControllerListFactoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoriesControllerListFactoriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoriesControllerListFactories>>> = ({ signal }) => factoriesControllerListFactories(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FactoriesControllerListFactoriesQueryResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerListFactories>>>
export type FactoriesControllerListFactoriesQueryError = void


export function useFactoriesControllerListFactories<TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(
 params: FactoriesControllerListFactoriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoriesControllerListFactories>>,
          TError,
          Awaited<ReturnType<typeof factoriesControllerListFactories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerListFactories<TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(
 params: FactoriesControllerListFactoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoriesControllerListFactories>>,
          TError,
          Awaited<ReturnType<typeof factoriesControllerListFactories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerListFactories<TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(
 params: FactoriesControllerListFactoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List factories for a partner
 */

export function useFactoriesControllerListFactories<TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(
 params: FactoriesControllerListFactoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFactoriesControllerListFactoriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List factories for a partner
 */
export const prefetchFactoriesControllerListFactoriesQuery = async <TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(
 queryClient: QueryClient, params: FactoriesControllerListFactoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFactoriesControllerListFactoriesQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getFactoriesControllerListFactoriesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(params: FactoriesControllerListFactoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoriesControllerListFactoriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoriesControllerListFactories>>> = ({ signal }) => factoriesControllerListFactories(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FactoriesControllerListFactoriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerListFactories>>>
export type FactoriesControllerListFactoriesSuspenseQueryError = void


export function useFactoriesControllerListFactoriesSuspense<TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(
 params: FactoriesControllerListFactoriesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerListFactoriesSuspense<TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(
 params: FactoriesControllerListFactoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerListFactoriesSuspense<TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(
 params: FactoriesControllerListFactoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List factories for a partner
 */

export function useFactoriesControllerListFactoriesSuspense<TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(
 params: FactoriesControllerListFactoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFactoriesControllerListFactoriesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type factoriesControllerCreateFactoryResponse201 = {
  data: FactoryDto
  status: 201
}

export type factoriesControllerCreateFactoryResponse403 = {
  data: void
  status: 403
}

export type factoriesControllerCreateFactoryResponse404 = {
  data: void
  status: 404
}

export type factoriesControllerCreateFactoryResponse409 = {
  data: void
  status: 409
}

export type factoriesControllerCreateFactoryResponseSuccess = (factoriesControllerCreateFactoryResponse201) & {
  headers: Headers;
};
export type factoriesControllerCreateFactoryResponseError = (factoriesControllerCreateFactoryResponse403 | factoriesControllerCreateFactoryResponse404 | factoriesControllerCreateFactoryResponse409) & {
  headers: Headers;
};

export type factoriesControllerCreateFactoryResponse = (factoriesControllerCreateFactoryResponseSuccess | factoriesControllerCreateFactoryResponseError)

export const getFactoriesControllerCreateFactoryUrl = () => {




  return `/factories`
}

/**
 * Creates a factory for the given partner. Restricted to Artic admins.
 * @summary Create a factory (Artic admin only)
 */
export const factoriesControllerCreateFactory = async (createFactoryDto: CreateFactoryDto, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerCreateFactoryResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<factoriesControllerCreateFactoryResponse>(getFactoriesControllerCreateFactoryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createFactoryDto)
  }
);}





export const getFactoriesControllerCreateFactoryMutationKey = () => ['factoriesControllerCreateFactory'] as const;

export const getFactoriesControllerCreateFactoryMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerCreateFactory>>, TError,FactoriesControllerCreateFactoryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerCreateFactory>>, TError,FactoriesControllerCreateFactoryMutationVariables, TContext> => {

const mutationKey = getFactoriesControllerCreateFactoryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerCreateFactory>>, FactoriesControllerCreateFactoryMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  factoriesControllerCreateFactory(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerCreateFactoryMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerCreateFactory>>>
    export type FactoriesControllerCreateFactoryMutationBody = CreateFactoryDto
    export type FactoriesControllerCreateFactoryMutationError = void
    export type FactoriesControllerCreateFactoryMutationVariables = {data: CreateFactoryDto}

    /**
 * @summary Create a factory (Artic admin only)
 */
export const useFactoriesControllerCreateFactory = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerCreateFactory>>, TError,FactoriesControllerCreateFactoryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerCreateFactory>>,
        TError,
        FactoriesControllerCreateFactoryMutationVariables,
        TContext
      > => {
      return useMutation(getFactoriesControllerCreateFactoryMutationOptions(options), queryClient);
    }
    export type factoriesControllerGetComplexityMappingsResponse200 = {
  data: FactoryComplexityMappingDto[]
  status: 200
}

export type factoriesControllerGetComplexityMappingsResponse404 = {
  data: void
  status: 404
}

export type factoriesControllerGetComplexityMappingsResponseSuccess = (factoriesControllerGetComplexityMappingsResponse200) & {
  headers: Headers;
};
export type factoriesControllerGetComplexityMappingsResponseError = (factoriesControllerGetComplexityMappingsResponse404) & {
  headers: Headers;
};

export type factoriesControllerGetComplexityMappingsResponse = (factoriesControllerGetComplexityMappingsResponseSuccess | factoriesControllerGetComplexityMappingsResponseError)

export const getFactoriesControllerGetComplexityMappingsUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/complexity-mappings`
}

/**
 * Returns the labour-minute rows (complexity 1..5) configured for this factory. Callers must be a member of the factory-owning partner; admins bypass this check.
 * @summary List complexity-score → labour-minutes mappings for a factory
 */
export const factoriesControllerGetComplexityMappings = async (factoryId: string, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerGetComplexityMappingsResponse> => {

  return customFetch<factoriesControllerGetComplexityMappingsResponse>(getFactoriesControllerGetComplexityMappingsUrl(factoryId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFactoriesControllerGetComplexityMappingsQueryKey = (factoryId: string,) => {
    return [
    `/factories/${factoryId}/complexity-mappings`
    ] as const;
    }


export const getFactoriesControllerGetComplexityMappingsQueryOptions = <TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoriesControllerGetComplexityMappingsQueryKey(factoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>> = ({ signal }) => factoriesControllerGetComplexityMappings(factoryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FactoriesControllerGetComplexityMappingsQueryResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>>
export type FactoriesControllerGetComplexityMappingsQueryError = void


export function useFactoriesControllerGetComplexityMappings<TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(
 factoryId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>,
          TError,
          Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerGetComplexityMappings<TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>,
          TError,
          Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerGetComplexityMappings<TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List complexity-score → labour-minutes mappings for a factory
 */

export function useFactoriesControllerGetComplexityMappings<TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFactoriesControllerGetComplexityMappingsQueryOptions(factoryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List complexity-score → labour-minutes mappings for a factory
 */
export const prefetchFactoriesControllerGetComplexityMappingsQuery = async <TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(
 queryClient: QueryClient, factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFactoriesControllerGetComplexityMappingsQueryOptions(factoryId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getFactoriesControllerGetComplexityMappingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoriesControllerGetComplexityMappingsQueryKey(factoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>> = ({ signal }) => factoriesControllerGetComplexityMappings(factoryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FactoriesControllerGetComplexityMappingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>>
export type FactoriesControllerGetComplexityMappingsSuspenseQueryError = void


export function useFactoriesControllerGetComplexityMappingsSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(
 factoryId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerGetComplexityMappingsSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerGetComplexityMappingsSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List complexity-score → labour-minutes mappings for a factory
 */

export function useFactoriesControllerGetComplexityMappingsSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFactoriesControllerGetComplexityMappingsSuspenseQueryOptions(factoryId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type factoriesControllerGetZonesResponse200 = {
  data: FactoryTopologyDto
  status: 200
}

export type factoriesControllerGetZonesResponse404 = {
  data: void
  status: 404
}

export type factoriesControllerGetZonesResponseSuccess = (factoriesControllerGetZonesResponse200) & {
  headers: Headers;
};
export type factoriesControllerGetZonesResponseError = (factoriesControllerGetZonesResponse404) & {
  headers: Headers;
};

export type factoriesControllerGetZonesResponse = (factoriesControllerGetZonesResponseSuccess | factoriesControllerGetZonesResponseError)

export const getFactoriesControllerGetZonesUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/zones`
}

/**
 * Returns the factory with its zones, each containing its stations — the contents of one factory tab in the Factory Admin view. Includes archived zones/stations (flagged via is_archived). Callers must be a member of the factory-owning partner.
 * @summary Factory topology: zones with their stations
 */
export const factoriesControllerGetZones = async (factoryId: string, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerGetZonesResponse> => {

  return customFetch<factoriesControllerGetZonesResponse>(getFactoriesControllerGetZonesUrl(factoryId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFactoriesControllerGetZonesQueryKey = (factoryId: string,) => {
    return [
    `/factories/${factoryId}/zones`
    ] as const;
    }


export const getFactoriesControllerGetZonesQueryOptions = <TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoriesControllerGetZonesQueryKey(factoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoriesControllerGetZones>>> = ({ signal }) => factoriesControllerGetZones(factoryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FactoriesControllerGetZonesQueryResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerGetZones>>>
export type FactoriesControllerGetZonesQueryError = void


export function useFactoriesControllerGetZones<TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(
 factoryId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoriesControllerGetZones>>,
          TError,
          Awaited<ReturnType<typeof factoriesControllerGetZones>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerGetZones<TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoriesControllerGetZones>>,
          TError,
          Awaited<ReturnType<typeof factoriesControllerGetZones>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerGetZones<TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Factory topology: zones with their stations
 */

export function useFactoriesControllerGetZones<TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFactoriesControllerGetZonesQueryOptions(factoryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Factory topology: zones with their stations
 */
export const prefetchFactoriesControllerGetZonesQuery = async <TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(
 queryClient: QueryClient, factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFactoriesControllerGetZonesQueryOptions(factoryId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getFactoriesControllerGetZonesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoriesControllerGetZonesQueryKey(factoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoriesControllerGetZones>>> = ({ signal }) => factoriesControllerGetZones(factoryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FactoriesControllerGetZonesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerGetZones>>>
export type FactoriesControllerGetZonesSuspenseQueryError = void


export function useFactoriesControllerGetZonesSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(
 factoryId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerGetZonesSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerGetZonesSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Factory topology: zones with their stations
 */

export function useFactoriesControllerGetZonesSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFactoriesControllerGetZonesSuspenseQueryOptions(factoryId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type factoriesControllerCreateZoneResponse201 = {
  data: ZoneNodeDto
  status: 201
}

export type factoriesControllerCreateZoneResponse409 = {
  data: void
  status: 409
}

export type factoriesControllerCreateZoneResponseSuccess = (factoriesControllerCreateZoneResponse201) & {
  headers: Headers;
};
export type factoriesControllerCreateZoneResponseError = (factoriesControllerCreateZoneResponse409) & {
  headers: Headers;
};

export type factoriesControllerCreateZoneResponse = (factoriesControllerCreateZoneResponseSuccess | factoriesControllerCreateZoneResponseError)

export const getFactoriesControllerCreateZoneUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/zones`
}

/**
 * @summary Create a zone in a factory
 */
export const factoriesControllerCreateZone = async (factoryId: string,
    createZoneDto: CreateZoneDto, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerCreateZoneResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<factoriesControllerCreateZoneResponse>(getFactoriesControllerCreateZoneUrl(factoryId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createZoneDto)
  }
);}





export const getFactoriesControllerCreateZoneMutationKey = () => ['factoriesControllerCreateZone'] as const;

export const getFactoriesControllerCreateZoneMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerCreateZone>>, TError,FactoriesControllerCreateZoneMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerCreateZone>>, TError,FactoriesControllerCreateZoneMutationVariables, TContext> => {

const mutationKey = getFactoriesControllerCreateZoneMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerCreateZone>>, FactoriesControllerCreateZoneMutationVariables> = (props) => {
          const {factoryId,data} = props ?? {};

          return  factoriesControllerCreateZone(factoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerCreateZoneMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerCreateZone>>>
    export type FactoriesControllerCreateZoneMutationBody = CreateZoneDto
    export type FactoriesControllerCreateZoneMutationError = void
    export type FactoriesControllerCreateZoneMutationVariables = {factoryId: string;data: CreateZoneDto}

    /**
 * @summary Create a zone in a factory
 */
export const useFactoriesControllerCreateZone = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerCreateZone>>, TError,FactoriesControllerCreateZoneMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerCreateZone>>,
        TError,
        FactoriesControllerCreateZoneMutationVariables,
        TContext
      > => {
      return useMutation(getFactoriesControllerCreateZoneMutationOptions(options), queryClient);
    }
    export type factoriesControllerDownloadStationScanLabelResponse200 = {
  data: Blob
  status: 200
}

export type factoriesControllerDownloadStationScanLabelResponse401 = {
  data: void
  status: 401
}

export type factoriesControllerDownloadStationScanLabelResponse403 = {
  data: void
  status: 403
}

export type factoriesControllerDownloadStationScanLabelResponse404 = {
  data: void
  status: 404
}

export type factoriesControllerDownloadStationScanLabelResponse409 = {
  data: void
  status: 409
}

export type factoriesControllerDownloadStationScanLabelResponseSuccess = (factoriesControllerDownloadStationScanLabelResponse200) & {
  headers: Headers;
};
export type factoriesControllerDownloadStationScanLabelResponseError = (factoriesControllerDownloadStationScanLabelResponse401 | factoriesControllerDownloadStationScanLabelResponse403 | factoriesControllerDownloadStationScanLabelResponse404 | factoriesControllerDownloadStationScanLabelResponse409) & {
  headers: Headers;
};

export type factoriesControllerDownloadStationScanLabelResponse = (factoriesControllerDownloadStationScanLabelResponseSuccess | factoriesControllerDownloadStationScanLabelResponseError)

export const getFactoriesControllerDownloadStationScanLabelUrl = (factoryId: string,
    zoneId: string,
    stationId: string,) => {




  return `/factories/${factoryId}/zones/${zoneId}/stations/${stationId}/scan-label`
}

/**
 * Renders a printable 200mm × 63mm station label. Its QR code contains the current partner, factory, zone, and station names expected by the Artic Production Control App Connect To Station scanner. Archived stations cannot generate labels.
 * @summary Download a station scan label (PDF)
 */
export const factoriesControllerDownloadStationScanLabel = async (factoryId: string,
    zoneId: string,
    stationId: string, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerDownloadStationScanLabelResponse> => {

  return customFetch<factoriesControllerDownloadStationScanLabelResponse>(getFactoriesControllerDownloadStationScanLabelUrl(factoryId,zoneId,stationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFactoriesControllerDownloadStationScanLabelQueryKey = (factoryId: string,
    zoneId: string,
    stationId: string,) => {
    return [
    `/factories/${factoryId}/zones/${zoneId}/stations/${stationId}/scan-label`
    ] as const;
    }


export const getFactoriesControllerDownloadStationScanLabelQueryOptions = <TData = Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError = void>(factoryId: string,
    zoneId: string,
    stationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoriesControllerDownloadStationScanLabelQueryKey(factoryId,zoneId,stationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>> = ({ signal }) => factoriesControllerDownloadStationScanLabel(factoryId,zoneId,stationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined && zoneId !== null && zoneId !== undefined && stationId !== null && stationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FactoriesControllerDownloadStationScanLabelQueryResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>>
export type FactoriesControllerDownloadStationScanLabelQueryError = void


export function useFactoriesControllerDownloadStationScanLabel<TData = Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError = void>(
 factoryId: string,
    zoneId: string,
    stationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>,
          TError,
          Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerDownloadStationScanLabel<TData = Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError = void>(
 factoryId: string,
    zoneId: string,
    stationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>,
          TError,
          Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerDownloadStationScanLabel<TData = Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError = void>(
 factoryId: string,
    zoneId: string,
    stationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download a station scan label (PDF)
 */

export function useFactoriesControllerDownloadStationScanLabel<TData = Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError = void>(
 factoryId: string,
    zoneId: string,
    stationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFactoriesControllerDownloadStationScanLabelQueryOptions(factoryId,zoneId,stationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Download a station scan label (PDF)
 */
export const prefetchFactoriesControllerDownloadStationScanLabelQuery = async <TData = Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError = void>(
 queryClient: QueryClient, factoryId: string,
    zoneId: string,
    stationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFactoriesControllerDownloadStationScanLabelQueryOptions(factoryId,zoneId,stationId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getFactoriesControllerDownloadStationScanLabelSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError = void>(factoryId: string,
    zoneId: string,
    stationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoriesControllerDownloadStationScanLabelQueryKey(factoryId,zoneId,stationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>> = ({ signal }) => factoriesControllerDownloadStationScanLabel(factoryId,zoneId,stationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FactoriesControllerDownloadStationScanLabelSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>>
export type FactoriesControllerDownloadStationScanLabelSuspenseQueryError = void


export function useFactoriesControllerDownloadStationScanLabelSuspense<TData = Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError = void>(
 factoryId: string,
    zoneId: string,
    stationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerDownloadStationScanLabelSuspense<TData = Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError = void>(
 factoryId: string,
    zoneId: string,
    stationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerDownloadStationScanLabelSuspense<TData = Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError = void>(
 factoryId: string,
    zoneId: string,
    stationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download a station scan label (PDF)
 */

export function useFactoriesControllerDownloadStationScanLabelSuspense<TData = Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError = void>(
 factoryId: string,
    zoneId: string,
    stationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerDownloadStationScanLabel>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFactoriesControllerDownloadStationScanLabelSuspenseQueryOptions(factoryId,zoneId,stationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type factoriesControllerGetOperationsStationsGridResponse200 = {
  data: OperationsStationsGridDto
  status: 200
}

export type factoriesControllerGetOperationsStationsGridResponse404 = {
  data: void
  status: 404
}

export type factoriesControllerGetOperationsStationsGridResponseSuccess = (factoriesControllerGetOperationsStationsGridResponse200) & {
  headers: Headers;
};
export type factoriesControllerGetOperationsStationsGridResponseError = (factoriesControllerGetOperationsStationsGridResponse404) & {
  headers: Headers;
};

export type factoriesControllerGetOperationsStationsGridResponse = (factoriesControllerGetOperationsStationsGridResponseSuccess | factoriesControllerGetOperationsStationsGridResponseError)

export const getFactoriesControllerGetOperationsStationsGridUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/operations-stations-grid`
}

/**
 * One-shot fetch for the Factory Settings Stations x Operations grid: every current-version operation owned by the factory's partner, every live station in this factory, and the compact set of enabled (operation_id, station_id) pairs (an operations_stations row exists). The frontend builds a Set from enabled_pairs to render checkbox state.
 * @summary Operations x Stations enablement grid for a factory
 */
export const factoriesControllerGetOperationsStationsGrid = async (factoryId: string, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerGetOperationsStationsGridResponse> => {

  return customFetch<factoriesControllerGetOperationsStationsGridResponse>(getFactoriesControllerGetOperationsStationsGridUrl(factoryId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFactoriesControllerGetOperationsStationsGridQueryKey = (factoryId: string,) => {
    return [
    `/factories/${factoryId}/operations-stations-grid`
    ] as const;
    }


export const getFactoriesControllerGetOperationsStationsGridQueryOptions = <TData = Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError = void>(factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoriesControllerGetOperationsStationsGridQueryKey(factoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>> = ({ signal }) => factoriesControllerGetOperationsStationsGrid(factoryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FactoriesControllerGetOperationsStationsGridQueryResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>>
export type FactoriesControllerGetOperationsStationsGridQueryError = void


export function useFactoriesControllerGetOperationsStationsGrid<TData = Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError = void>(
 factoryId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>,
          TError,
          Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerGetOperationsStationsGrid<TData = Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>,
          TError,
          Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerGetOperationsStationsGrid<TData = Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Operations x Stations enablement grid for a factory
 */

export function useFactoriesControllerGetOperationsStationsGrid<TData = Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFactoriesControllerGetOperationsStationsGridQueryOptions(factoryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Operations x Stations enablement grid for a factory
 */
export const prefetchFactoriesControllerGetOperationsStationsGridQuery = async <TData = Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError = void>(
 queryClient: QueryClient, factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFactoriesControllerGetOperationsStationsGridQueryOptions(factoryId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getFactoriesControllerGetOperationsStationsGridSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError = void>(factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoriesControllerGetOperationsStationsGridQueryKey(factoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>> = ({ signal }) => factoriesControllerGetOperationsStationsGrid(factoryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FactoriesControllerGetOperationsStationsGridSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>>
export type FactoriesControllerGetOperationsStationsGridSuspenseQueryError = void


export function useFactoriesControllerGetOperationsStationsGridSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError = void>(
 factoryId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerGetOperationsStationsGridSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoriesControllerGetOperationsStationsGridSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Operations x Stations enablement grid for a factory
 */

export function useFactoriesControllerGetOperationsStationsGridSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetOperationsStationsGrid>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFactoriesControllerGetOperationsStationsGridSuspenseQueryOptions(factoryId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type factoriesControllerBulkSetOperationsStationsGridResponse200 = {
  data: OperationsStationsGridBulkToggleResultDto
  status: 200
}

export type factoriesControllerBulkSetOperationsStationsGridResponse400 = {
  data: void
  status: 400
}

export type factoriesControllerBulkSetOperationsStationsGridResponse404 = {
  data: void
  status: 404
}

export type factoriesControllerBulkSetOperationsStationsGridResponseSuccess = (factoriesControllerBulkSetOperationsStationsGridResponse200) & {
  headers: Headers;
};
export type factoriesControllerBulkSetOperationsStationsGridResponseError = (factoriesControllerBulkSetOperationsStationsGridResponse400 | factoriesControllerBulkSetOperationsStationsGridResponse404) & {
  headers: Headers;
};

export type factoriesControllerBulkSetOperationsStationsGridResponse = (factoriesControllerBulkSetOperationsStationsGridResponseSuccess | factoriesControllerBulkSetOperationsStationsGridResponseError)

export const getFactoriesControllerBulkSetOperationsStationsGridUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/operations-stations-grid/bulk`
}

/**
 * Toggles operations_stations rows for one station across the supplied operation_ids in a single transaction — enabling inserts (idempotent), disabling deletes. Each real change is audited the same as the single-operation toggle (PATCH /operations/:operation_id/stations). Rolls back entirely if the station or any operation_id does not belong to this factory / partner — this is a direct write and does NOT go through Run Sheet change control.
 * @summary Bulk enable/disable one station across multiple operations
 */
export const factoriesControllerBulkSetOperationsStationsGrid = async (factoryId: string,
    operationsStationsGridBulkToggleDto: OperationsStationsGridBulkToggleDto, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerBulkSetOperationsStationsGridResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<factoriesControllerBulkSetOperationsStationsGridResponse>(getFactoriesControllerBulkSetOperationsStationsGridUrl(factoryId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(operationsStationsGridBulkToggleDto)
  }
);}





export const getFactoriesControllerBulkSetOperationsStationsGridMutationKey = () => ['factoriesControllerBulkSetOperationsStationsGrid'] as const;

export const getFactoriesControllerBulkSetOperationsStationsGridMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerBulkSetOperationsStationsGrid>>, TError,FactoriesControllerBulkSetOperationsStationsGridMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerBulkSetOperationsStationsGrid>>, TError,FactoriesControllerBulkSetOperationsStationsGridMutationVariables, TContext> => {

const mutationKey = getFactoriesControllerBulkSetOperationsStationsGridMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerBulkSetOperationsStationsGrid>>, FactoriesControllerBulkSetOperationsStationsGridMutationVariables> = (props) => {
          const {factoryId,data} = props ?? {};

          return  factoriesControllerBulkSetOperationsStationsGrid(factoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerBulkSetOperationsStationsGridMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerBulkSetOperationsStationsGrid>>>
    export type FactoriesControllerBulkSetOperationsStationsGridMutationBody = OperationsStationsGridBulkToggleDto
    export type FactoriesControllerBulkSetOperationsStationsGridMutationError = void
    export type FactoriesControllerBulkSetOperationsStationsGridMutationVariables = {factoryId: string;data: OperationsStationsGridBulkToggleDto}

    /**
 * @summary Bulk enable/disable one station across multiple operations
 */
export const useFactoriesControllerBulkSetOperationsStationsGrid = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerBulkSetOperationsStationsGrid>>, TError,FactoriesControllerBulkSetOperationsStationsGridMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerBulkSetOperationsStationsGrid>>,
        TError,
        FactoriesControllerBulkSetOperationsStationsGridMutationVariables,
        TContext
      > => {
      return useMutation(getFactoriesControllerBulkSetOperationsStationsGridMutationOptions(options), queryClient);
    }
    export type factoriesControllerUpdateFactoryResponse200 = {
  data: FactoryDto
  status: 200
}

export type factoriesControllerUpdateFactoryResponse403 = {
  data: void
  status: 403
}

export type factoriesControllerUpdateFactoryResponse404 = {
  data: void
  status: 404
}

export type factoriesControllerUpdateFactoryResponse409 = {
  data: void
  status: 409
}

export type factoriesControllerUpdateFactoryResponseSuccess = (factoriesControllerUpdateFactoryResponse200) & {
  headers: Headers;
};
export type factoriesControllerUpdateFactoryResponseError = (factoriesControllerUpdateFactoryResponse403 | factoriesControllerUpdateFactoryResponse404 | factoriesControllerUpdateFactoryResponse409) & {
  headers: Headers;
};

export type factoriesControllerUpdateFactoryResponse = (factoriesControllerUpdateFactoryResponseSuccess | factoriesControllerUpdateFactoryResponseError)

export const getFactoriesControllerUpdateFactoryUrl = (factoryId: string,) => {




  return `/factories/${factoryId}`
}

/**
 * Renames a factory and/or changes its timezone. Restricted to Artic admins.
 * @summary Edit factory details (Artic admin only)
 */
export const factoriesControllerUpdateFactory = async (factoryId: string,
    updateFactoryDto: UpdateFactoryDto, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerUpdateFactoryResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<factoriesControllerUpdateFactoryResponse>(getFactoriesControllerUpdateFactoryUrl(factoryId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateFactoryDto)
  }
);}





export const getFactoriesControllerUpdateFactoryMutationKey = () => ['factoriesControllerUpdateFactory'] as const;

export const getFactoriesControllerUpdateFactoryMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUpdateFactory>>, TError,FactoriesControllerUpdateFactoryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUpdateFactory>>, TError,FactoriesControllerUpdateFactoryMutationVariables, TContext> => {

const mutationKey = getFactoriesControllerUpdateFactoryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerUpdateFactory>>, FactoriesControllerUpdateFactoryMutationVariables> = (props) => {
          const {factoryId,data} = props ?? {};

          return  factoriesControllerUpdateFactory(factoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerUpdateFactoryMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerUpdateFactory>>>
    export type FactoriesControllerUpdateFactoryMutationBody = UpdateFactoryDto
    export type FactoriesControllerUpdateFactoryMutationError = void
    export type FactoriesControllerUpdateFactoryMutationVariables = {factoryId: string;data: UpdateFactoryDto}

    /**
 * @summary Edit factory details (Artic admin only)
 */
export const useFactoriesControllerUpdateFactory = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUpdateFactory>>, TError,FactoriesControllerUpdateFactoryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerUpdateFactory>>,
        TError,
        FactoriesControllerUpdateFactoryMutationVariables,
        TContext
      > => {
      return useMutation(getFactoriesControllerUpdateFactoryMutationOptions(options), queryClient);
    }
    export type factoriesControllerArchiveFactoryResponse201 = {
  data: FactoryDto
  status: 201
}

export type factoriesControllerArchiveFactoryResponseSuccess = (factoriesControllerArchiveFactoryResponse201) & {
  headers: Headers;
};
;

export type factoriesControllerArchiveFactoryResponse = (factoriesControllerArchiveFactoryResponseSuccess)

export const getFactoriesControllerArchiveFactoryUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/archive`
}

/**
 * @summary Archive a factory (Artic admin only)
 */
export const factoriesControllerArchiveFactory = async (factoryId: string, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerArchiveFactoryResponse> => {

  return customFetch<factoriesControllerArchiveFactoryResponse>(getFactoriesControllerArchiveFactoryUrl(factoryId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getFactoriesControllerArchiveFactoryMutationKey = () => ['factoriesControllerArchiveFactory'] as const;

export const getFactoriesControllerArchiveFactoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerArchiveFactory>>, TError,FactoriesControllerArchiveFactoryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerArchiveFactory>>, TError,FactoriesControllerArchiveFactoryMutationVariables, TContext> => {

const mutationKey = getFactoriesControllerArchiveFactoryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerArchiveFactory>>, FactoriesControllerArchiveFactoryMutationVariables> = (props) => {
          const {factoryId} = props ?? {};

          return  factoriesControllerArchiveFactory(factoryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerArchiveFactoryMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerArchiveFactory>>>

    export type FactoriesControllerArchiveFactoryMutationError = unknown
    export type FactoriesControllerArchiveFactoryMutationVariables = {factoryId: string}

    /**
 * @summary Archive a factory (Artic admin only)
 */
export const useFactoriesControllerArchiveFactory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerArchiveFactory>>, TError,FactoriesControllerArchiveFactoryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerArchiveFactory>>,
        TError,
        FactoriesControllerArchiveFactoryMutationVariables,
        TContext
      > => {
      return useMutation(getFactoriesControllerArchiveFactoryMutationOptions(options), queryClient);
    }
    export type factoriesControllerUnarchiveFactoryResponse201 = {
  data: FactoryDto
  status: 201
}

export type factoriesControllerUnarchiveFactoryResponseSuccess = (factoriesControllerUnarchiveFactoryResponse201) & {
  headers: Headers;
};
;

export type factoriesControllerUnarchiveFactoryResponse = (factoriesControllerUnarchiveFactoryResponseSuccess)

export const getFactoriesControllerUnarchiveFactoryUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/unarchive`
}

/**
 * @summary Unarchive a factory (Artic admin only)
 */
export const factoriesControllerUnarchiveFactory = async (factoryId: string, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerUnarchiveFactoryResponse> => {

  return customFetch<factoriesControllerUnarchiveFactoryResponse>(getFactoriesControllerUnarchiveFactoryUrl(factoryId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getFactoriesControllerUnarchiveFactoryMutationKey = () => ['factoriesControllerUnarchiveFactory'] as const;

export const getFactoriesControllerUnarchiveFactoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUnarchiveFactory>>, TError,FactoriesControllerUnarchiveFactoryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUnarchiveFactory>>, TError,FactoriesControllerUnarchiveFactoryMutationVariables, TContext> => {

const mutationKey = getFactoriesControllerUnarchiveFactoryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerUnarchiveFactory>>, FactoriesControllerUnarchiveFactoryMutationVariables> = (props) => {
          const {factoryId} = props ?? {};

          return  factoriesControllerUnarchiveFactory(factoryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerUnarchiveFactoryMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerUnarchiveFactory>>>

    export type FactoriesControllerUnarchiveFactoryMutationError = unknown
    export type FactoriesControllerUnarchiveFactoryMutationVariables = {factoryId: string}

    /**
 * @summary Unarchive a factory (Artic admin only)
 */
export const useFactoriesControllerUnarchiveFactory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUnarchiveFactory>>, TError,FactoriesControllerUnarchiveFactoryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerUnarchiveFactory>>,
        TError,
        FactoriesControllerUnarchiveFactoryMutationVariables,
        TContext
      > => {
      return useMutation(getFactoriesControllerUnarchiveFactoryMutationOptions(options), queryClient);
    }
    export type factoriesControllerUpdateFactoryQualitySettingsResponse200 = {
  data: FactoryQualitySettingsDto
  status: 200
}

export type factoriesControllerUpdateFactoryQualitySettingsResponse400 = {
  data: void
  status: 400
}

export type factoriesControllerUpdateFactoryQualitySettingsResponse404 = {
  data: void
  status: 404
}

export type factoriesControllerUpdateFactoryQualitySettingsResponseSuccess = (factoriesControllerUpdateFactoryQualitySettingsResponse200) & {
  headers: Headers;
};
export type factoriesControllerUpdateFactoryQualitySettingsResponseError = (factoriesControllerUpdateFactoryQualitySettingsResponse400 | factoriesControllerUpdateFactoryQualitySettingsResponse404) & {
  headers: Headers;
};

export type factoriesControllerUpdateFactoryQualitySettingsResponse = (factoriesControllerUpdateFactoryQualitySettingsResponseSuccess | factoriesControllerUpdateFactoryQualitySettingsResponseError)

export const getFactoriesControllerUpdateFactoryQualitySettingsUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/quality-settings`
}

/**
 * Sets any of the four Rework Closure / Time to Correct threshold minutes for a factory. Unset fields keep their current value; the request is merged onto the current row before validation, so the merged result must satisfy watch < breaching < closure minutes. Partner-scoped: any member of the owning partner may call this (not Artic-admin only).
 * @summary Update Quality Dashboard threshold settings for a factory
 */
export const factoriesControllerUpdateFactoryQualitySettings = async (factoryId: string,
    updateFactoryQualitySettingsDto: UpdateFactoryQualitySettingsDto, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerUpdateFactoryQualitySettingsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<factoriesControllerUpdateFactoryQualitySettingsResponse>(getFactoriesControllerUpdateFactoryQualitySettingsUrl(factoryId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateFactoryQualitySettingsDto)
  }
);}





export const getFactoriesControllerUpdateFactoryQualitySettingsMutationKey = () => ['factoriesControllerUpdateFactoryQualitySettings'] as const;

export const getFactoriesControllerUpdateFactoryQualitySettingsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUpdateFactoryQualitySettings>>, TError,FactoriesControllerUpdateFactoryQualitySettingsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUpdateFactoryQualitySettings>>, TError,FactoriesControllerUpdateFactoryQualitySettingsMutationVariables, TContext> => {

const mutationKey = getFactoriesControllerUpdateFactoryQualitySettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerUpdateFactoryQualitySettings>>, FactoriesControllerUpdateFactoryQualitySettingsMutationVariables> = (props) => {
          const {factoryId,data} = props ?? {};

          return  factoriesControllerUpdateFactoryQualitySettings(factoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerUpdateFactoryQualitySettingsMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerUpdateFactoryQualitySettings>>>
    export type FactoriesControllerUpdateFactoryQualitySettingsMutationBody = UpdateFactoryQualitySettingsDto
    export type FactoriesControllerUpdateFactoryQualitySettingsMutationError = void
    export type FactoriesControllerUpdateFactoryQualitySettingsMutationVariables = {factoryId: string;data: UpdateFactoryQualitySettingsDto}

    /**
 * @summary Update Quality Dashboard threshold settings for a factory
 */
export const useFactoriesControllerUpdateFactoryQualitySettings = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUpdateFactoryQualitySettings>>, TError,FactoriesControllerUpdateFactoryQualitySettingsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerUpdateFactoryQualitySettings>>,
        TError,
        FactoriesControllerUpdateFactoryQualitySettingsMutationVariables,
        TContext
      > => {
      return useMutation(getFactoriesControllerUpdateFactoryQualitySettingsMutationOptions(options), queryClient);
    }
    export type factoriesControllerReorderZonesResponse204 = {
  data: void
  status: 204
}

export type factoriesControllerReorderZonesResponse400 = {
  data: void
  status: 400
}

export type factoriesControllerReorderZonesResponseSuccess = (factoriesControllerReorderZonesResponse204) & {
  headers: Headers;
};
export type factoriesControllerReorderZonesResponseError = (factoriesControllerReorderZonesResponse400) & {
  headers: Headers;
};

export type factoriesControllerReorderZonesResponse = (factoriesControllerReorderZonesResponseSuccess | factoriesControllerReorderZonesResponseError)

export const getFactoriesControllerReorderZonesUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/zones/sequence`
}

/**
 * Reassigns zone_sequence across the factory's zones to match the supplied order; index 0 maps to zone_sequence 1. The complete ordered array of zone_ids must be supplied, archived zones included — a partial list is rejected because renumbering a subset would leave duplicate positions behind.
 * @summary Reorder the zones in a factory
 */
export const factoriesControllerReorderZones = async (factoryId: string,
    reorderZonesDto: ReorderZonesDto, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerReorderZonesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<factoriesControllerReorderZonesResponse>(getFactoriesControllerReorderZonesUrl(factoryId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reorderZonesDto)
  }
);}





export const getFactoriesControllerReorderZonesMutationKey = () => ['factoriesControllerReorderZones'] as const;

export const getFactoriesControllerReorderZonesMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerReorderZones>>, TError,FactoriesControllerReorderZonesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerReorderZones>>, TError,FactoriesControllerReorderZonesMutationVariables, TContext> => {

const mutationKey = getFactoriesControllerReorderZonesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerReorderZones>>, FactoriesControllerReorderZonesMutationVariables> = (props) => {
          const {factoryId,data} = props ?? {};

          return  factoriesControllerReorderZones(factoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerReorderZonesMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerReorderZones>>>
    export type FactoriesControllerReorderZonesMutationBody = ReorderZonesDto
    export type FactoriesControllerReorderZonesMutationError = void
    export type FactoriesControllerReorderZonesMutationVariables = {factoryId: string;data: ReorderZonesDto}

    /**
 * @summary Reorder the zones in a factory
 */
export const useFactoriesControllerReorderZones = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerReorderZones>>, TError,FactoriesControllerReorderZonesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerReorderZones>>,
        TError,
        FactoriesControllerReorderZonesMutationVariables,
        TContext
      > => {
      return useMutation(getFactoriesControllerReorderZonesMutationOptions(options), queryClient);
    }
    export type factoriesControllerRenameZoneResponse200 = {
  data: void
  status: 200
}

export type factoriesControllerRenameZoneResponse409 = {
  data: void
  status: 409
}

export type factoriesControllerRenameZoneResponseSuccess = (factoriesControllerRenameZoneResponse200) & {
  headers: Headers;
};
export type factoriesControllerRenameZoneResponseError = (factoriesControllerRenameZoneResponse409) & {
  headers: Headers;
};

export type factoriesControllerRenameZoneResponse = (factoriesControllerRenameZoneResponseSuccess | factoriesControllerRenameZoneResponseError)

export const getFactoriesControllerRenameZoneUrl = (factoryId: string,
    zoneId: string,) => {




  return `/factories/${factoryId}/zones/${zoneId}`
}

/**
 * @summary Rename a zone
 */
export const factoriesControllerRenameZone = async (factoryId: string,
    zoneId: string,
    renameZoneDto: RenameZoneDto, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerRenameZoneResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<factoriesControllerRenameZoneResponse>(getFactoriesControllerRenameZoneUrl(factoryId,zoneId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(renameZoneDto)
  }
);}





export const getFactoriesControllerRenameZoneMutationKey = () => ['factoriesControllerRenameZone'] as const;

export const getFactoriesControllerRenameZoneMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerRenameZone>>, TError,FactoriesControllerRenameZoneMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerRenameZone>>, TError,FactoriesControllerRenameZoneMutationVariables, TContext> => {

const mutationKey = getFactoriesControllerRenameZoneMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerRenameZone>>, FactoriesControllerRenameZoneMutationVariables> = (props) => {
          const {factoryId,zoneId,data} = props ?? {};

          return  factoriesControllerRenameZone(factoryId,zoneId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerRenameZoneMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerRenameZone>>>
    export type FactoriesControllerRenameZoneMutationBody = RenameZoneDto
    export type FactoriesControllerRenameZoneMutationError = void
    export type FactoriesControllerRenameZoneMutationVariables = {factoryId: string;zoneId: string;data: RenameZoneDto}

    /**
 * @summary Rename a zone
 */
export const useFactoriesControllerRenameZone = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerRenameZone>>, TError,FactoriesControllerRenameZoneMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerRenameZone>>,
        TError,
        FactoriesControllerRenameZoneMutationVariables,
        TContext
      > => {
      return useMutation(getFactoriesControllerRenameZoneMutationOptions(options), queryClient);
    }
    export type factoriesControllerArchiveZoneResponse201 = {
  data: void
  status: 201
}

export type factoriesControllerArchiveZoneResponseSuccess = (factoriesControllerArchiveZoneResponse201) & {
  headers: Headers;
};
;

export type factoriesControllerArchiveZoneResponse = (factoriesControllerArchiveZoneResponseSuccess)

export const getFactoriesControllerArchiveZoneUrl = (factoryId: string,
    zoneId: string,) => {




  return `/factories/${factoryId}/zones/${zoneId}/archive`
}

/**
 * @summary Archive a zone
 */
export const factoriesControllerArchiveZone = async (factoryId: string,
    zoneId: string, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerArchiveZoneResponse> => {

  return customFetch<factoriesControllerArchiveZoneResponse>(getFactoriesControllerArchiveZoneUrl(factoryId,zoneId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getFactoriesControllerArchiveZoneMutationKey = () => ['factoriesControllerArchiveZone'] as const;

export const getFactoriesControllerArchiveZoneMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerArchiveZone>>, TError,FactoriesControllerArchiveZoneMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerArchiveZone>>, TError,FactoriesControllerArchiveZoneMutationVariables, TContext> => {

const mutationKey = getFactoriesControllerArchiveZoneMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerArchiveZone>>, FactoriesControllerArchiveZoneMutationVariables> = (props) => {
          const {factoryId,zoneId} = props ?? {};

          return  factoriesControllerArchiveZone(factoryId,zoneId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerArchiveZoneMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerArchiveZone>>>

    export type FactoriesControllerArchiveZoneMutationError = unknown
    export type FactoriesControllerArchiveZoneMutationVariables = {factoryId: string;zoneId: string}

    /**
 * @summary Archive a zone
 */
export const useFactoriesControllerArchiveZone = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerArchiveZone>>, TError,FactoriesControllerArchiveZoneMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerArchiveZone>>,
        TError,
        FactoriesControllerArchiveZoneMutationVariables,
        TContext
      > => {
      return useMutation(getFactoriesControllerArchiveZoneMutationOptions(options), queryClient);
    }
    export type factoriesControllerUnarchiveZoneResponse201 = {
  data: void
  status: 201
}

export type factoriesControllerUnarchiveZoneResponseSuccess = (factoriesControllerUnarchiveZoneResponse201) & {
  headers: Headers;
};
;

export type factoriesControllerUnarchiveZoneResponse = (factoriesControllerUnarchiveZoneResponseSuccess)

export const getFactoriesControllerUnarchiveZoneUrl = (factoryId: string,
    zoneId: string,) => {




  return `/factories/${factoryId}/zones/${zoneId}/unarchive`
}

/**
 * @summary Unarchive a zone
 */
export const factoriesControllerUnarchiveZone = async (factoryId: string,
    zoneId: string, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerUnarchiveZoneResponse> => {

  return customFetch<factoriesControllerUnarchiveZoneResponse>(getFactoriesControllerUnarchiveZoneUrl(factoryId,zoneId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getFactoriesControllerUnarchiveZoneMutationKey = () => ['factoriesControllerUnarchiveZone'] as const;

export const getFactoriesControllerUnarchiveZoneMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUnarchiveZone>>, TError,FactoriesControllerUnarchiveZoneMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUnarchiveZone>>, TError,FactoriesControllerUnarchiveZoneMutationVariables, TContext> => {

const mutationKey = getFactoriesControllerUnarchiveZoneMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerUnarchiveZone>>, FactoriesControllerUnarchiveZoneMutationVariables> = (props) => {
          const {factoryId,zoneId} = props ?? {};

          return  factoriesControllerUnarchiveZone(factoryId,zoneId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerUnarchiveZoneMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerUnarchiveZone>>>

    export type FactoriesControllerUnarchiveZoneMutationError = unknown
    export type FactoriesControllerUnarchiveZoneMutationVariables = {factoryId: string;zoneId: string}

    /**
 * @summary Unarchive a zone
 */
export const useFactoriesControllerUnarchiveZone = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUnarchiveZone>>, TError,FactoriesControllerUnarchiveZoneMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerUnarchiveZone>>,
        TError,
        FactoriesControllerUnarchiveZoneMutationVariables,
        TContext
      > => {
      return useMutation(getFactoriesControllerUnarchiveZoneMutationOptions(options), queryClient);
    }
    export type factoriesControllerCreateStationResponse201 = {
  data: StationNodeDto
  status: 201
}

export type factoriesControllerCreateStationResponse409 = {
  data: void
  status: 409
}

export type factoriesControllerCreateStationResponseSuccess = (factoriesControllerCreateStationResponse201) & {
  headers: Headers;
};
export type factoriesControllerCreateStationResponseError = (factoriesControllerCreateStationResponse409) & {
  headers: Headers;
};

export type factoriesControllerCreateStationResponse = (factoriesControllerCreateStationResponseSuccess | factoriesControllerCreateStationResponseError)

export const getFactoriesControllerCreateStationUrl = (factoryId: string,
    zoneId: string,) => {




  return `/factories/${factoryId}/zones/${zoneId}/stations`
}

/**
 * @summary Create a station in a zone
 */
export const factoriesControllerCreateStation = async (factoryId: string,
    zoneId: string,
    addStationDto: AddStationDto, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerCreateStationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<factoriesControllerCreateStationResponse>(getFactoriesControllerCreateStationUrl(factoryId,zoneId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addStationDto)
  }
);}





export const getFactoriesControllerCreateStationMutationKey = () => ['factoriesControllerCreateStation'] as const;

export const getFactoriesControllerCreateStationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerCreateStation>>, TError,FactoriesControllerCreateStationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerCreateStation>>, TError,FactoriesControllerCreateStationMutationVariables, TContext> => {

const mutationKey = getFactoriesControllerCreateStationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerCreateStation>>, FactoriesControllerCreateStationMutationVariables> = (props) => {
          const {factoryId,zoneId,data} = props ?? {};

          return  factoriesControllerCreateStation(factoryId,zoneId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerCreateStationMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerCreateStation>>>
    export type FactoriesControllerCreateStationMutationBody = AddStationDto
    export type FactoriesControllerCreateStationMutationError = void
    export type FactoriesControllerCreateStationMutationVariables = {factoryId: string;zoneId: string;data: AddStationDto}

    /**
 * @summary Create a station in a zone
 */
export const useFactoriesControllerCreateStation = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerCreateStation>>, TError,FactoriesControllerCreateStationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerCreateStation>>,
        TError,
        FactoriesControllerCreateStationMutationVariables,
        TContext
      > => {
      return useMutation(getFactoriesControllerCreateStationMutationOptions(options), queryClient);
    }
    export type factoriesControllerReorderStationsResponse204 = {
  data: void
  status: 204
}

export type factoriesControllerReorderStationsResponse400 = {
  data: void
  status: 400
}

export type factoriesControllerReorderStationsResponseSuccess = (factoriesControllerReorderStationsResponse204) & {
  headers: Headers;
};
export type factoriesControllerReorderStationsResponseError = (factoriesControllerReorderStationsResponse400) & {
  headers: Headers;
};

export type factoriesControllerReorderStationsResponse = (factoriesControllerReorderStationsResponseSuccess | factoriesControllerReorderStationsResponseError)

export const getFactoriesControllerReorderStationsUrl = (factoryId: string,
    zoneId: string,) => {




  return `/factories/${factoryId}/zones/${zoneId}/stations/sequence`
}

/**
 * Reassigns station_sequence across the zone's stations to match the supplied order; index 0 maps to station_sequence 1. The complete ordered array of station_ids must be supplied, archived stations included — a partial list is rejected because renumbering a subset would leave duplicate positions behind.
 * @summary Reorder the stations in a zone
 */
export const factoriesControllerReorderStations = async (factoryId: string,
    zoneId: string,
    reorderStationsDto: ReorderStationsDto, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerReorderStationsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<factoriesControllerReorderStationsResponse>(getFactoriesControllerReorderStationsUrl(factoryId,zoneId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reorderStationsDto)
  }
);}





export const getFactoriesControllerReorderStationsMutationKey = () => ['factoriesControllerReorderStations'] as const;

export const getFactoriesControllerReorderStationsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerReorderStations>>, TError,FactoriesControllerReorderStationsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerReorderStations>>, TError,FactoriesControllerReorderStationsMutationVariables, TContext> => {

const mutationKey = getFactoriesControllerReorderStationsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerReorderStations>>, FactoriesControllerReorderStationsMutationVariables> = (props) => {
          const {factoryId,zoneId,data} = props ?? {};

          return  factoriesControllerReorderStations(factoryId,zoneId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerReorderStationsMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerReorderStations>>>
    export type FactoriesControllerReorderStationsMutationBody = ReorderStationsDto
    export type FactoriesControllerReorderStationsMutationError = void
    export type FactoriesControllerReorderStationsMutationVariables = {factoryId: string;zoneId: string;data: ReorderStationsDto}

    /**
 * @summary Reorder the stations in a zone
 */
export const useFactoriesControllerReorderStations = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerReorderStations>>, TError,FactoriesControllerReorderStationsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerReorderStations>>,
        TError,
        FactoriesControllerReorderStationsMutationVariables,
        TContext
      > => {
      return useMutation(getFactoriesControllerReorderStationsMutationOptions(options), queryClient);
    }
    export type factoriesControllerUpdateStationResponse200 = {
  data: void
  status: 200
}

export type factoriesControllerUpdateStationResponse400 = {
  data: void
  status: 400
}

export type factoriesControllerUpdateStationResponse409 = {
  data: void
  status: 409
}

export type factoriesControllerUpdateStationResponseSuccess = (factoriesControllerUpdateStationResponse200) & {
  headers: Headers;
};
export type factoriesControllerUpdateStationResponseError = (factoriesControllerUpdateStationResponse400 | factoriesControllerUpdateStationResponse409) & {
  headers: Headers;
};

export type factoriesControllerUpdateStationResponse = (factoriesControllerUpdateStationResponseSuccess | factoriesControllerUpdateStationResponseError)

export const getFactoriesControllerUpdateStationUrl = (factoryId: string,
    zoneId: string,
    stationId: string,) => {




  return `/factories/${factoryId}/zones/${zoneId}/stations/${stationId}`
}

/**
 * Renames a station and/or moves it to another zone within the same factory. Name must remain unique within the destination zone.
 * @summary Rename and/or move a station
 */
export const factoriesControllerUpdateStation = async (factoryId: string,
    zoneId: string,
    stationId: string,
    editStationDto: EditStationDto, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerUpdateStationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<factoriesControllerUpdateStationResponse>(getFactoriesControllerUpdateStationUrl(factoryId,zoneId,stationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(editStationDto)
  }
);}





export const getFactoriesControllerUpdateStationMutationKey = () => ['factoriesControllerUpdateStation'] as const;

export const getFactoriesControllerUpdateStationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUpdateStation>>, TError,FactoriesControllerUpdateStationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUpdateStation>>, TError,FactoriesControllerUpdateStationMutationVariables, TContext> => {

const mutationKey = getFactoriesControllerUpdateStationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerUpdateStation>>, FactoriesControllerUpdateStationMutationVariables> = (props) => {
          const {factoryId,zoneId,stationId,data} = props ?? {};

          return  factoriesControllerUpdateStation(factoryId,zoneId,stationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerUpdateStationMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerUpdateStation>>>
    export type FactoriesControllerUpdateStationMutationBody = EditStationDto
    export type FactoriesControllerUpdateStationMutationError = void
    export type FactoriesControllerUpdateStationMutationVariables = {factoryId: string;zoneId: string;stationId: string;data: EditStationDto}

    /**
 * @summary Rename and/or move a station
 */
export const useFactoriesControllerUpdateStation = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUpdateStation>>, TError,FactoriesControllerUpdateStationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerUpdateStation>>,
        TError,
        FactoriesControllerUpdateStationMutationVariables,
        TContext
      > => {
      return useMutation(getFactoriesControllerUpdateStationMutationOptions(options), queryClient);
    }
    export type factoriesControllerArchiveStationResponse201 = {
  data: void
  status: 201
}

export type factoriesControllerArchiveStationResponseSuccess = (factoriesControllerArchiveStationResponse201) & {
  headers: Headers;
};
;

export type factoriesControllerArchiveStationResponse = (factoriesControllerArchiveStationResponseSuccess)

export const getFactoriesControllerArchiveStationUrl = (factoryId: string,
    zoneId: string,
    stationId: string,) => {




  return `/factories/${factoryId}/zones/${zoneId}/stations/${stationId}/archive`
}

/**
 * @summary Archive a station
 */
export const factoriesControllerArchiveStation = async (factoryId: string,
    zoneId: string,
    stationId: string, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerArchiveStationResponse> => {

  return customFetch<factoriesControllerArchiveStationResponse>(getFactoriesControllerArchiveStationUrl(factoryId,zoneId,stationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getFactoriesControllerArchiveStationMutationKey = () => ['factoriesControllerArchiveStation'] as const;

export const getFactoriesControllerArchiveStationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerArchiveStation>>, TError,FactoriesControllerArchiveStationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerArchiveStation>>, TError,FactoriesControllerArchiveStationMutationVariables, TContext> => {

const mutationKey = getFactoriesControllerArchiveStationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerArchiveStation>>, FactoriesControllerArchiveStationMutationVariables> = (props) => {
          const {factoryId,zoneId,stationId} = props ?? {};

          return  factoriesControllerArchiveStation(factoryId,zoneId,stationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerArchiveStationMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerArchiveStation>>>

    export type FactoriesControllerArchiveStationMutationError = unknown
    export type FactoriesControllerArchiveStationMutationVariables = {factoryId: string;zoneId: string;stationId: string}

    /**
 * @summary Archive a station
 */
export const useFactoriesControllerArchiveStation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerArchiveStation>>, TError,FactoriesControllerArchiveStationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerArchiveStation>>,
        TError,
        FactoriesControllerArchiveStationMutationVariables,
        TContext
      > => {
      return useMutation(getFactoriesControllerArchiveStationMutationOptions(options), queryClient);
    }
    export type factoriesControllerUnarchiveStationResponse201 = {
  data: void
  status: 201
}

export type factoriesControllerUnarchiveStationResponseSuccess = (factoriesControllerUnarchiveStationResponse201) & {
  headers: Headers;
};
;

export type factoriesControllerUnarchiveStationResponse = (factoriesControllerUnarchiveStationResponseSuccess)

export const getFactoriesControllerUnarchiveStationUrl = (factoryId: string,
    zoneId: string,
    stationId: string,) => {




  return `/factories/${factoryId}/zones/${zoneId}/stations/${stationId}/unarchive`
}

/**
 * @summary Unarchive a station
 */
export const factoriesControllerUnarchiveStation = async (factoryId: string,
    zoneId: string,
    stationId: string, options?: Parameters<typeof customFetch>[1]): Promise<factoriesControllerUnarchiveStationResponse> => {

  return customFetch<factoriesControllerUnarchiveStationResponse>(getFactoriesControllerUnarchiveStationUrl(factoryId,zoneId,stationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getFactoriesControllerUnarchiveStationMutationKey = () => ['factoriesControllerUnarchiveStation'] as const;

export const getFactoriesControllerUnarchiveStationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUnarchiveStation>>, TError,FactoriesControllerUnarchiveStationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUnarchiveStation>>, TError,FactoriesControllerUnarchiveStationMutationVariables, TContext> => {

const mutationKey = getFactoriesControllerUnarchiveStationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerUnarchiveStation>>, FactoriesControllerUnarchiveStationMutationVariables> = (props) => {
          const {factoryId,zoneId,stationId} = props ?? {};

          return  factoriesControllerUnarchiveStation(factoryId,zoneId,stationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerUnarchiveStationMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerUnarchiveStation>>>

    export type FactoriesControllerUnarchiveStationMutationError = unknown
    export type FactoriesControllerUnarchiveStationMutationVariables = {factoryId: string;zoneId: string;stationId: string}

    /**
 * @summary Unarchive a station
 */
export const useFactoriesControllerUnarchiveStation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUnarchiveStation>>, TError,FactoriesControllerUnarchiveStationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerUnarchiveStation>>,
        TError,
        FactoriesControllerUnarchiveStationMutationVariables,
        TContext
      > => {
      return useMutation(getFactoriesControllerUnarchiveStationMutationOptions(options), queryClient);
    }
